import _get from 'lodash/get';
import _chunk from 'lodash/chunk';
import {
  getCart,
  getHaveAShoppingCart,
  patchCart,
  postCart,
  deleteProductCart,
  putCart,
  postCartInfo,
} from 'services/giftTableCart';
import { getProductsById } from 'services/api/products';
import { showLoader, hideLoader } from 'store/actions/commons';
import { PROFILE_DATA } from 'constants/storage64';
import { decodeStorage } from 'functions/storageBase64';
import {
  addProductToProductsList,
  deleteProductToProductsList,
} from 'util/products';
import { isLogged, getBasePath } from 'services/commons';
import { isPaymentFlow, setLoginRedirect, setLoginRedirectGuest } from 'util/navigation';
import { transformCartProductList } from 'services/gifts/transformers';
import { transformProductCart } from 'services/giftTable/transformer';
import { getProductsWithPagination } from 'services/gifts';
import axios from 'axios';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';
import {
  FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS,
  FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_SUCCESS,
  FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_FAILED,
  CHANGE_PRODUCTS_PAGE,
  FETCH_SHOPPING_CART,
  FETCH_SHOPPING_CART_SUCCESS,
  FETCH_SHOPPING_CART_FAILED,
  UPDATE_SHOPPING_CART,
  UPDATE_SHOPPING_CART_SUCCESS,
  UPDATE_SHOPPING_CART_FAILED,
  ADD_SHOPPING_CART_PRODUCT,
  REMOVE_SHOPPING_CART_PRODUCT,
  CREATE_SHOPPING_CART,
  CREATE_SHOPPING_CART_SUCCESS,
  CREATE_SHOPPING_CART_FAILED,
  SET_TEMPORAL_PRODUCT_OF_NOT_LOGGED_USER,
  SET_LOGGED_AFTER_ADDING_TEMPORARY_PRODUCT,
  FETCH_GIFT_TABLE_INFO_SUCCESS,
  FETCH_GIFT_TABLE_INFO_FAILED,
  SET_SHOPPING_CART_PRICES,
  SET_HAVE_A_SHOPPING_CART,
  SET_SHOPPING_CART_INFO,
  RESET_EXTERNAL_GIFT_TABLE,
  UPDATE_CART_INFO,
  UPDATE_CART_INFO_SUCCESS,
  UPDATE_CART_INFO_FAILED,
} from './types';

const LIMIT = 20;

export const fetchExternalGiftTableProducts =
  (payload) => async (dispatch, state) => {
    const { params } = state.externalGiftTable.externalGiftTableProducts;
    const giftTable = payload || state.externalGiftTable.giftTableInfo.data;

    dispatch(showLoader());

    dispatch({ type: FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS, payload });

    try {
      const allGiftIds = giftTable?.gifts?.map((gift) => gift.product_id);

      const chunkAllGiftIds = _chunk(allGiftIds, LIMIT);

      const listGiftsData = await Promise.all(
        chunkAllGiftIds.map((list) => getProductsById(list, {}, true))
      );

      // eslint-disable-next-line prefer-spread
      const allGiftsData = [].concat.apply([], listGiftsData);

      const giftsWithVariants = payload ? payload?.gifts?.filter(g => g.variant_id) : [];

      // Only products with stock and status = true
      const allProducts = allGiftsData
        .map((i) => {
          if(i.variations?.length){
            let gift = [];
            const giftVariants = giftsWithVariants.filter(gwv => gwv.product_id === i.product_id);
            giftVariants.map((g) => {
              const variation = i.variations.filter(v => v.id === g.variant_id);
              variation.length && +variation[0].stock > 0 && i.status ? gift.push(i.id) : null;
            });
            return gift[0];
          }
          return i.stock > 0 && i.status ? i.id : null
        })
        .filter((i) => i);

      let tableInfoProducts = _get(
        state,
        'externalGiftTable.giftTableInfo.data.gifts',
        []
      );

      // Filter only products that match with allProducts
      tableInfoProducts = tableInfoProducts
        .map((t) => (allProducts.includes(t.product_id) ? t : null))
        .filter((t) => t);

      const productsWithPagination = await getProductsWithPagination({
        allProducts,
        params,
        tableInfoProducts,
        isExternal: true,
      });

      productsWithPagination.allElements = allProducts;

      dispatch(fetchExternalGiftTableProductsSuccess(productsWithPagination));

      // This action of fetch products is responsible of hide the loader
      dispatch(fetchShoppingCart({ tableId: giftTable.id }));
    } catch (error) {
      console.error(error);
      dispatch(fetchExternalGiftTableProductsFailed(error));
    } finally {
      dispatch(hideLoader());
    }
  };

export const fetchExternalGiftTableProductsSuccess = (payload) => ({
  type: FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_SUCCESS,
  payload,
});

export const fetchExternalGiftTableProductsFailed = (payload) => ({
  type: FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_FAILED,
  payload,
});

export const changeProductsPage = (payload) => async (dispatch, state) => {
  try {
    dispatch(showLoader());
    const params = _get(
      state,
      'externalGiftTable.externalGiftTableProducts.params',
      {}
    );
    const newParams = {
      ...params,
      ...payload,
    };
    const allProducts = _get(
      state,
      'externalGiftTable.externalGiftTableProducts.results.allElements',
      []
    );
    const tableInfoProducts = _get(
      state,
      'externalGiftTable.giftTableInfo.data.gifts',
      []
    );

    const productsWithPagination = await getProductsWithPagination({
      allProducts,
      params: newParams,
      tableInfoProducts,
      isExternal: true,
    });

    productsWithPagination.allElements = allProducts;

    dispatch({
      type: CHANGE_PRODUCTS_PAGE,
      payload: productsWithPagination,
    });
  } catch (error) {
    console.error(error);
    dispatch(fetchExternalGiftTableProductsFailed(error));
  } finally {
    dispatch(hideLoader());
  }
};

export const fetchShoppingCart =
  (payload = {}) =>
  async (dispatch, state) => {
    const {
      shoppingCart = {},
      temporalProductOfNotLoggedUser,
      isLoggedAfterAddingTemporaryProduct,
    } = state.externalGiftTable;

    const giftTableId = _get(
      state,
      'externalGiftTable.giftTableInfo.data.id',
      ''
    );

    dispatch(showLoader());

    try {
      const profileData = decodeStorage(PROFILE_DATA);

      const listOfTableCartsParams = {
        customer_sears_id: profileData.idClaro,
        gifttable_id: giftTableId,
      };

      const [withShoppingCart, cartInfo] = await getHaveAShoppingCart(
        listOfTableCartsParams
      );

      dispatch(setHaveAShoppingCart(withShoppingCart));
      dispatch(setShoppingCartInfo(cartInfo));

      if (withShoppingCart) {
        dispatch({ type: FETCH_SHOPPING_CART, payload });

        const cart = await getCart({
          id: cartInfo.cart_id,
          ...shoppingCart.params,
        });

        const listOfProductsId = cart.list.products.map(
          (product) => product.product_sears_id
        );

        const giftsProducts = await getProductsById(listOfProductsId, {}, true);

        cart.list.products = transformCartProductList(
          cart.list.products,
          giftsProducts
        );

        dispatch(fetchShoppingCartSuccess(cart));

        dispatch({
          type: ADD_SHOPPING_CART_PRODUCT,
          payload: cart.list.products,
        });
        if (
          temporalProductOfNotLoggedUser &&
          isLoggedAfterAddingTemporaryProduct
        ) {
          dispatch(updateShoppingCart(temporalProductOfNotLoggedUser));
        }
        dispatch(hideLoader());
      } else if (withShoppingCart === false) {
        if (isPaymentFlow()) {
          window.location.href = `${getBasePath()}my-table`;
          return;
        }

        if (temporalProductOfNotLoggedUser) {
          // This is responsible of reset temporalProductOfNotLoggedUser and isLoggedAfterAddingTemporaryProduct state, and hide loader
          dispatch(createShoppingCart(temporalProductOfNotLoggedUser));
          return;
        }

        dispatch(hideLoader());
      }
    } catch (error) {
      if (error?.response?.status) {
        const notFoundCart = error.response.status === 404;
        if (notFoundCart && isPaymentFlow()) {
          window.location.href = `${getBasePath()}my-table`;
          return;
        }

        if (
          notFoundCart &&
          temporalProductOfNotLoggedUser &&
          isLoggedAfterAddingTemporaryProduct
        ) {
          dispatch(createShoppingCart(temporalProductOfNotLoggedUser));
        }
      }

      dispatch(fetchShoppingCartFailed(error));
    } finally {
      if (
        !temporalProductOfNotLoggedUser ||
        !isLoggedAfterAddingTemporaryProduct
      ) {
        dispatch(hideLoader());
      }
    }
  };

export const fetchShoppingCartSuccess = (payload) => ({
  type: FETCH_SHOPPING_CART_SUCCESS,
  payload,
});

export const fetchShoppingCartFailed = (payload) => ({
  type: FETCH_SHOPPING_CART_FAILED,
  payload,
});

export const updateShoppingCart =
  ({ cartId, withLoader = false, hasDelete = false, clearCart = false, ...payload } = {}) =>
  async (dispatch) => {
    if (!cartId) return;

    if (withLoader) await dispatch(showLoader());

    dispatch({ type: UPDATE_SHOPPING_CART, payload });

    const productBody = transformProductCart(payload, hasDelete);

    try {
      const params = { id: cartId, ...productBody };
      const response = hasDelete
        ? await deleteProductCart(params)
        : await patchCart(params);
      dispatch(updateShoppingCartSuccess(response));
      clearCart && dispatch(setHaveAShoppingCart(false));
      return true;
    } catch (error) {
      dispatch(updateShoppingCartFailed(error));
      return false;
    } finally {
      if (withLoader) await dispatch(hideLoader());
    }
  };

export const updateShoppingCartSuccess = (payload) => ({
  type: UPDATE_SHOPPING_CART_SUCCESS,
  payload,
});

export const updateShoppingCartFailed = (payload) => ({
  type: UPDATE_SHOPPING_CART_FAILED,
  payload,
});
const getHrefWitoutSpecificPath = (pathToRemove) => {
  const listOfPaths = window.location.href.split('/');
  return listOfPaths
    .filter((path) => path !== pathToRemove && path)
    .join('/')
    .replace(/:\//g, '://');
};
export const addShoppingCartProduct =
  (payload) => async (dispatch, state) => {
    // Check is logged
    //        Ajunstando para guestcheckout
    let hasLogged = isLogged();
    //  console.log("Objeto hasLogged:",hasLogged);

    if (localStorage.getItem("guest_email") !== null){
      hasLogged = true;
      console.log("Se forza el loggin por guest checkout");
    } else {
      console.log("No existe el mail (sesion invitado)");
    }

    //  console.log("Objeto payload ",payload);
    if (!hasLogged) {
      dispatch(setTemporalProductOfNotLoggedUser(payload));
      const location = getHrefWitoutSpecificPath();
      //  console.log("En hsLogged, Objeto location ",location);
      setLoginRedirect(location, true, hasLogged, false, true);
      return;
    }

    const { shoppingCartProducts, haveAShoppingCart } = state.externalGiftTable;
    const { data: products = [] } = shoppingCartProducts;
    //  console.log("Objeto haveAShoppingCart: ",haveAShoppingCart);
    if (haveAShoppingCart) {
      const cartId = _get(
        state,
        'externalGiftTable.shoppingCartInfo.data.cart_id',
        ''
      );
      //  console.log("Objeto cartId: ",cartId);
      const response = await dispatch(updateShoppingCart({ cartId, ...payload }));

      if (response) {
        const newProducts = addProductToProductsList(payload, products, true);
        dispatch({ type: ADD_SHOPPING_CART_PRODUCT, payload: newProducts });  
      }

      return response;
    } else {
      return await dispatch(createShoppingCart(payload));
    }
  };

export const removeShoppingCartProduct = (payload) => async (dispatch, state) => {
  const { data: products = [] } = state.externalGiftTable.shoppingCartProducts;

  const newProducts = deleteProductToProductsList(payload, products);

  const cartId = _get(
    state,
    'externalGiftTable.shoppingCartInfo.data.cart_id',
    ''
  );

  const product = {
    ...payload,
    quantity: 0,
  };

  const clearCart = !newProducts.length;
  
  const response = await dispatch(
    updateShoppingCart(
      { cartId, ...product, withLoader: true, hasDelete: true, clearCart }
    )
  );

  response && dispatch({ type: REMOVE_SHOPPING_CART_PRODUCT, payload: newProducts });

  return response;
};

export const createShoppingCart =
  ({ withLoader = true, ...payload } = {}) =>
  async (dispatch, state) => {
    if (withLoader) await dispatch(showLoader());

    dispatch({ type: CREATE_SHOPPING_CART, payload });

    const tableId = _get(state, 'externalGiftTable.giftTableInfo.data.id', '');
    const profileData = decodeStorage(PROFILE_DATA);

    try {
      const productBody = {
        customer_sears_id: profileData.idClaro,
        customer_sears_email: profileData.correo,

        //  ENVIO DE CORREO Y TELEFONO AL CREAR EL CARRITO
        guest_email : localStorage.getItem("guest_email"),
        guest_phone_number : localStorage.getItem("guest_phone_number"),
      //  customer_type : "guest",    //  guest/registered
        ...transformProductCart(payload),
      };

      const cartData = await postCart({ tableId, ...productBody });

      // Guarda el car_id en el local storage
      localStorage.setItem("cart_id", cartData.cart_id);
      //  console.log("cartData: ", cartData.cart_id);
      dispatch(createShoppingCartSuccess(cartData));

      // This action is responsible of hide the loader
      dispatch(fetchShoppingCart());
      return true;
    } catch (error) {
      dispatch(createShoppingCartFailed(error));
      if (withLoader) await dispatch(hideLoader());
      return false;
    }
  };

export const createShoppingCartSuccess = (payload) => ({
  type: CREATE_SHOPPING_CART_SUCCESS,
  payload,
});

export const createShoppingCartFailed = (payload) => ({
  type: CREATE_SHOPPING_CART_FAILED,
  payload,
});

export const setTemporalProductOfNotLoggedUser = (payload) => ({
  type: SET_TEMPORAL_PRODUCT_OF_NOT_LOGGED_USER,
  payload,
});

export const setLoggedAfterAddingTemporaryProduct = (payload) => ({
  type: SET_LOGGED_AFTER_ADDING_TEMPORARY_PRODUCT,
  payload,
});

export const fetchExternalGiftTableInfoSuccess = (payload) => ({
  type: FETCH_GIFT_TABLE_INFO_SUCCESS,
  payload,
});

export const fetchExternalGiftTableInfoFailed = (payload) => ({
  type: FETCH_GIFT_TABLE_INFO_FAILED,
  payload,
});

export const setShoppingCartPrices = (payload) => ({
  type: SET_SHOPPING_CART_PRICES,
  payload,
});

export const setHaveAShoppingCart = (payload) => ({
  type: SET_HAVE_A_SHOPPING_CART,
  payload,
});

export const setShoppingCartInfo = (payload) => ({
  type: SET_SHOPPING_CART_INFO,
  payload,
});

export const resetExternalGiftTable = () => ({
  type: RESET_EXTERNAL_GIFT_TABLE,
});

export const updateCartInfo =
  ({ ...payload } = {}, paymentIsAccepted = false) =>
  async (dispatch, state) => {
    //  console.log("Inicnado updateCartInfo: ", paymentIsAccepted);
    dispatch(showLoader());

    dispatch({ type: UPDATE_CART_INFO, payload });

    const cartId = _get(
      state,
      'externalGiftTable.shoppingCartInfo.data.cart_id',
      ''
    );

    // WAITING FOR REAL FLUX

    const tableId = _get(state, 'externalGiftTable.giftTableInfo.data.id', '');
    const tableTypeId = _get(
      state,
      'externalGiftTable.giftTableInfo.data.type.id',
      ''
    );

    const addressId = _get(
      state,
      'externalGiftTable.giftTableInfo.data.customer.address_id',
      null
    );
    const wallet_code = _get(
      state,
      'externalGiftTable.giftTableInfo.data.wallet.wallet_code',
      null
    );
    const giftsProducts = _get(
      state,
      'externalGiftTable.shoppingCartInfo.data.products',
      []
    ).map((product) => ({
      product_sears_id: product.product_sears_id,
      children_sku_sears: product.children_sku_sears,
      quantity: product.quantity,
    }));

    const profileData = decodeStorage(PROFILE_DATA);

    try {
      const putCartData = {
        id: cartId,
        guest_name: payload.name,
        congrats_message: payload.welcomeMessage,
        congrats_to_celebrated_id: payload.giftDirected,
      };

      // Waiting for real flux
      // const MOCK_POST_CART_DATA = {
      //   gift_table_id: '232131',
      //   gift_table_type: 'traditional',
      //   customer_sears_id: '2475015',
      //   cart_id: '1212',
      //   walled_code: '12312312312',
      //   address_id: 172632,
      //   gift_table_message: 'asdasdajshdkjaslhdkajsd',
      //   products: [
      //     {
      //       product_sears_id: '249620',
      //       variant_sears_id: '',
      //       quantity: 1,
      //     },
      //   ],
      // };

      // Waiting for real flux
      const apiURL = `${BASE_PATH_API}/${ROOT}/gift-table/${tableId}`;

      const config = {
        method: 'get',
        url: apiURL,
        withCredentials: false,
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      };
      const data = await axios(config);
      //  console.log("Configuracion de axios: ", config);
      //  console.log("Data de axios: ", data);

      const cartData = await putCart(putCartData);
      //  console.log('cartData en putCart ==>', cartData);
      
      //  console.log("paymentIsAccepted: ", paymentIsAccepted);
      if (paymentIsAccepted) {
        //  console.log("profileData.idClaro en postCartData",profileData.idClaro);
        const postCartData = {
            gift_table_id: tableId,
            gift_table_type: data.data.data.plan.id,
            customer_sears_id: profileData.idClaro,
            cart_id: cartId,
            wallet_code,
            address_id: addressId,
            gift_table_message: payload.welcomeMessage,
            products: giftsProducts,
          };

        //    Validar tipo de sesion (invitado o logueado) para agregar campos al JSON
        if(profileData.idClaro === undefined){
          //  console.log("Agregando campos a postCartData para invitado");
          postCartData.customer_sears_id = 0;
          postCartData.guest_email = localStorage.getItem("guest_email");
          postCartData.guest_phone_number = localStorage.getItem("guest_phone_number");
        }

        //  console.log('postCartData en postCartInfo ==>', JSON.stringify(postCartData));
        const [{ redirect, access_token }, key, status] = await postCartInfo(postCartData);

        if(access_token){
          const domain = window.location.hostname;
          document.cookie = `token_login=${access_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
          //  Cerrar sesion invitado
          window.localStorage.removeItem("cart_id");
          window.localStorage.removeItem("guest_email");
          window.localStorage.removeItem("guest_phone_number");
          console.log("Cerrando sesion Invitado ");
          //  console.log("Access token recibido: ", access_token, domain);
        }else{
          const domain = window.location.hostname;
          //  document.cookie = `token_login_jwt=${'1111111111111111111111111'};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
          //  console.log("No se recibio access token",access_token, domain);
        }

        window.localStorage.setItem(key.identifier, key.value);
        //  console.log('Redirect ==>', redirect);
        //  console.log('key ==>', key);

        // Redirection to payment flux
        window.location.href = redirect;
      }

      dispatch(updateCartInfoSuccess(cartData));
    } catch (error) {
      dispatch(
        updateCartInfoFailed(
          error.response
            ? error.response.data.metadata.message
            : 'Ocurrió un error inesperado, intenta de nuevo.'
        )
      );
    } finally {
      dispatch(hideLoader());
    }
  };

export const updateCartInfoSuccess = (payload) => ({
  type: UPDATE_CART_INFO_SUCCESS,
  payload,
});

export const updateCartInfoFailed = (payload) => ({
  type: UPDATE_CART_INFO_FAILED,
  payload,
});
